import { API_BASE, MAIN_SITE_URL } from './config'

export interface LoginResult {
  sessionToken: string
  user?: unknown
}

export interface Login2FAPending {
  requires2FA: true
  tempToken: string
}

export type LoginResponse = LoginResult | Login2FAPending

export function is2FAPending(res: LoginResponse): res is Login2FAPending {
  return 'requires2FA' in res && res.requires2FA === true
}

export async function loginWithPassword(email: string, password: string): Promise<LoginResponse> {
  const res = await fetch(`${API_BASE}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || `Login failed (${res.status})`)
  }
  if ((data as { requires2FA?: boolean }).requires2FA && (data as { tempToken?: string }).tempToken) {
    return { requires2FA: true, tempToken: (data as { tempToken: string }).tempToken }
  }
  const sessionToken = (data as { sessionToken?: string }).sessionToken
  if (!sessionToken) throw new Error('No session token received')
  return { sessionToken, user: (data as { user?: unknown }).user }
}

export async function verifyLogin2FA(tempToken: string, code: string): Promise<LoginResult> {
  const res = await fetch(`${API_BASE}/api/login/verify-2fa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tempToken, code: code.replace(/\D/g, '').slice(0, 6) }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || `Verification failed (${res.status})`)
  }
  const sessionToken = (data as { sessionToken?: string }).sessionToken
  if (!sessionToken) throw new Error('No session token received')
  return { sessionToken, user: (data as { user?: unknown }).user }
}

export function getLoginRedirectUrl(): string {
  const returnUrl = encodeURIComponent(`${window.location.origin}/auth/callback`)
  return `${MAIN_SITE_URL}/login.html?returnUrl=${returnUrl}`
}

export function hasStaffAccess(permissions: {
  viewReports?: boolean
  careersAdmin?: boolean
  manageStaff?: boolean
  roadmapAdmin?: boolean
  manageThemes?: boolean
} | null): boolean {
  if (!permissions) return false
  return !!(
    permissions.viewReports ||
    permissions.careersAdmin ||
    permissions.manageStaff ||
    permissions.roadmapAdmin ||
    permissions.manageThemes
  )
}
